module.exports = __webpack_public_path__ + "media/icons/plyny-eksploatacyjne-title-cf3ffdb8.png";